<template>
  <div class="">
    <div class="flex w-full relative top106">
      <div class="w-1/4 left-0 fixed">
        <div class="w-full">
          <CourseIndex :selectedCourse="selectedCourse" />
        </div>
      </div>
      <div class="w-3/4 absolute right-0">
        <div class="w-full">
          <Screen :selectedTopic="selectedTopic" />
          <Overview :selectedCourse="selectedCourse" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import "./../scss/index.scss";
import Screen from "./components/Screen.vue";
import CourseIndex from "./components/CourseIndex.vue";
import Overview from "./components/Overview.vue";
import { mapState } from "vuex";
// import  from "./components/.vue";
// import  from "./components/Reviews.vue";
export default {
  data() {
    return {};
  },
  components: {
    Screen,
    CourseIndex,
    Overview,
  },

  computed: {
    ...mapState("eLearning", ["selectedCourse"]),
    ...mapState("topic", ["selectedTopic"]),
  },
};
</script>
